"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _SZWBUSP4cjs = require('../__chunks/SZWBUSP4.cjs');


var _BSDSNAGPcjs = require('../__chunks/BSDSNAGP.cjs');
require('../__chunks/RF45TVVP.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/B5WROPFJ.cjs');


var _D7QSSCKRcjs = require('../__chunks/D7QSSCKR.cjs');
require('../__chunks/55GZX7VJ.cjs');
require('../__chunks/UI5KWBYV.cjs');
require('../__chunks/L634CRNJ.cjs');
require('../__chunks/MXP46NZ2.cjs');
require('../__chunks/5MLKOK3F.cjs');
require('../__chunks/YEIU6ILA.cjs');
require('../__chunks/W32FX7DM.cjs');
require('../__chunks/7AMN26AR.cjs');
require('../__chunks/6GRO3ZM4.cjs');
require('../__chunks/VP4WDOZF.cjs');
require('../__chunks/55HRZINU.cjs');
require('../__chunks/2UJOY5ZF.cjs');
require('../__chunks/JLMLKTUB.cjs');
require('../__chunks/LCWSLOYU.cjs');
require('../__chunks/V7JASX7S.cjs');
require('../__chunks/56NPFF7P.cjs');
require('../__chunks/GASMO7Y4.cjs');
require('../__chunks/6IFEN2M3.cjs');
require('../__chunks/26P4PLHI.cjs');
require('../__chunks/YVOQ2BCB.cjs');
require('../__chunks/4SKDRUBR.cjs');
require('../__chunks/AQ2LO7WV.cjs');
require('../__chunks/KEDCOTT4.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/VYZTFWCG.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/tooltip/tooltip.tsx
var _dom = require('@ariakit/core/utils/dom');
var _misc = require('@ariakit/core/utils/misc');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useTooltip = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useTooltip2({
    store,
    portal = true,
    gutter = 8,
    preserveTabOrder = false,
    hideOnHoverOutside = true,
    hideOnInteractOutside = true,
    ...props
  }) {
    const context = _SZWBUSP4cjs.useTooltipProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _SZWBUSP4cjs.TooltipScopedContextProvider, { value: store, children: element }),
      [store]
    );
    const role = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.type === "description" ? "tooltip" : "none"
    );
    props = { role, ...props };
    props = _BSDSNAGPcjs.useHovercard.call(void 0, {
      ...props,
      store,
      portal,
      gutter,
      preserveTabOrder,
      hideOnHoverOutside(event) {
        if (_misc.isFalsyBooleanCallback.call(void 0, hideOnHoverOutside, event)) return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement) return true;
        if ("focusVisible" in anchorElement.dataset) return false;
        return true;
      },
      hideOnInteractOutside: (event) => {
        if (_misc.isFalsyBooleanCallback.call(void 0, hideOnInteractOutside, event)) return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement) return true;
        if (_dom.contains.call(void 0, anchorElement, event.target)) return false;
        return true;
      }
    });
    return props;
  }
);
var Tooltip = _D7QSSCKRcjs.createDialogComponent.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function Tooltip2(props) {
    const htmlProps = useTooltip(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  }),
  _SZWBUSP4cjs.useTooltipProviderContext
);



exports.Tooltip = Tooltip; exports.useTooltip = useTooltip;
